// @ts-check

import React, { useMemo } from 'react';
import DatePicker from "react-datepicker";
import moment from "moment";

import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper.js';

import './weekPicker.scss';


/**
 * @param {{
*   selectedDate: moment.Moment | null,
*   onChange: (m: moment.Moment | null) => void
* }} props
*/
export default function WeekPicker(props) {

  let selectedDate = props.selectedDate;
  // console.log('selectedDate ===> ', selectedDate?.toString());

  // Memoize selected day week bounds in ms (respecting locale via startOf/endOf('week'))
  let { weekStartMs, weekEndMs } = useMemo(() => {
    if (!selectedDate) {
      return { weekStartMs: NaN, weekEndMs: NaN };
    }

    // return {
    //   weekStartMs: selectedDate.clone().startOf("week").valueOf(),
    //   weekEndMs: selectedDate.clone().endOf("week").valueOf(),
    // };

    // const start = selectedDate.clone().startOf("isoWeek"); // Monday
    // let start = selectedDate.clone().startOf("isoWeek"); // Monday
    // let end = start.clone().add(6, "day");               // Friday
    
    let start = DateTimeHelper.transformDateToStartOfWeekAuto(
      selectedDate.clone().utcOffset(0, true).toDate()
    );
    let end = moment(start).startOf('day').add(6, "day");
    
    // console.log('start ===> ', start?.toString());
    
    return { weekStartMs: start.valueOf(), weekEndMs: end.valueOf() };


  }, [selectedDate && selectedDate.valueOf()]);


  /**
   * @param {moment.Moment} m
   */
  let getDayClassName = (m) => {
    let epochMS = m.valueOf();
    let isBetween = (epochMS >= weekStartMs) && (epochMS <= weekEndMs);
    return isBetween ? "day-of-highlighted-week" : "";
  };


  /** 
   * @param {moment.Moment | null} momentDate
   * 
   */
  let onChange = (momentDate) => {

    let momentNoZone = momentDate ? momentDate.utcOffset(0, true) : null;

    if (props.onChange) {
      props.onChange(momentNoZone);
    }

  };



  return (
    <div className="pl-datepicker pl-datepicker-week-picker">
      
    <DatePicker
      // className='pl-datepicker'
      inline={true}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      selected={selectedDate}
      dateFormat={DateTimeHelper.getDateFormat()}
      onChange={onChange}
      showWeekNumbers={true}
      locale={DateTimeHelper.getUserOrgLocale()}
      // locale={"en-GB"}
      // locale={"en-US"}
      dayClassName={getDayClassName}
    />
    </div>

  );

}